module.exports = __webpack_public_path__ + "6166a521a07bad8fc5f2f99f8983372b.svg";